module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_pp1_3.0d45c5dd.png";